import { EnumSchema } from '../metadata-schema';

export const SoortVakpositie: EnumSchema = {
	"type": "string",
	"title": "SoortVakpositie",
	"enum": [
		"Gemeenschappelijk",
		"Profielvak",
		"Profielvak ster",
		"Profielmodule",
		"Sectorvak",
		"Keuzevak",
		"Keuzevak ster",
		"Beroepsgericht programma",
		"Bijlage"
	]
};
